import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { DeleteGeofenceDialog } from "../delete-dialog";
import { useDeleteGeofenceMutationV1 } from "@/api/v1/geofence-api";
import { toast } from "sonner";

interface DeleteGeofenceActionProps {
  geofenceId: string | number;
  geofenceName: string;
}

export function DeleteGeofenceAction({ geofenceId, geofenceName }: DeleteGeofenceActionProps) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const deleteGeofenceMutation = useDeleteGeofenceMutationV1();

  const handleDelete = async () => {
    try {
      await deleteGeofenceMutation.mutateAsync(geofenceId);
      toast.success("Geofence deleted successfully");
    } catch {
      toast.error("Failed to delete geofence");
    }
  };

  return (
    <>
      <Button 
        variant="ghost" 
        size="icon"
        onClick={() => setIsDeleteDialogOpen(true)}
      >
        <Trash2 className="h-4 w-4" />
      </Button>

      <DeleteGeofenceDialog
        isOpen={isDeleteDialogOpen}
        isDeleting={deleteGeofenceMutation.isPending}
        onOpenChange={setIsDeleteDialogOpen}
        onConfirm={handleDelete}
        geofenceName={geofenceName}
      />
    </>
  );
} 